module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.toast) ? _c('toast', {
    attrs: {
      "toast": _vm.toast
    }
  }) : _vm._e(), _vm._v(" "), _c('header-bar'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "scroll-section"
    }
  }, [_c('router-view'), _vm._v(" "), (_vm.$route.name !== 'USER_REPO_LIST') ? _c('footer-bar') : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-105cd270!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainContent.vue
// module id = 451
// module chunks = 2